var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.innerVisible,
        title: _vm.$t("Price.ConfigSurchargeFcl"),
        width: "740px",
        "close-on-click-modal": false,
        "destroy-on-close": true,
        top: "5vh",
        "custom-class": "surcharge-fcl-form-dialog details-view"
      },
      on: {
        "update:visible": function($event) {
          _vm.innerVisible = $event
        },
        close: _vm.cancel
      }
    },
    [
      _c("configure-the-surcharge", {
        attrs: {
          "config-module": "22320104",
          "grid-options": _vm.gridOptions,
          "select-length": _vm.selectLength
        },
        on: { confirm: _vm.onConfirm, cancel: _vm.onCancel }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }